export default {
    en: {
        cart_your_order: 'Your order',
        cart_price_details: 'Price details',
        cart_empty: 'Your cart is empty',
        go_to_homepage: 'Go to homepage',
        cart_reservation_time: 'Your tickets are reserved for 10 minutes.',
        cart_method_receive_tickets: 'How do you want to receive your tickets?',
        cart_method_receive_tickets_label: 'Electronic tickets (Email)',
        cart_issuance_fee: 'Tickets issuing fee',
        cart_transaction_fee: 'Transaction fee',
        cart_your_seats: 'Your seats',
        cart_seated_together: 'You\'ll be seated together',
        cart_continue_with_billing: 'Continue with billing',
        cart_you_added_tickets: 'You have {count} tickets in cart',
        cart_you_have_to_login: 'You have to login in your account.',
        cart_contact_details: 'Contact details',
        cart_contact_details_info: 'You will receive the ticket and order updates to your email.',
        cart_change_contact_details: 'Change contact details',
        cart_contact_details_title_modal: 'Enter the details of the person to whom you want to send the tickets',
        cart_buy_tickets: 'Buy tickets',
        cart_payment_type_and_billing: 'Payment method',
        cart_confirm_order: 'Confirm you order',
        cart_credit_cart: 'Credit or debit card',
        cart_expired: 'Looks like you haven’t added a event in your cart or the session has expired',
        waiting_payment: 'Waiting for payment confirmation...',
        select_payment_method: 'Select a payment method',
        all_details_corect: 'Are all details correct? Check and place order',
        give_it_up: 'Give it up',
        accept_terms_error: 'You must agree to the terms and conditions',
        cart_full_name_error: 'Please enter your full name',
    },
    ro: {
        cart_your_order: 'Comanda ta',
        cart_price_details: 'Detalii preț',
        cart_empty: 'Coșul tău este gol',
        go_to_homepage: 'Mergi la homepage',
        cart_reservation_time: 'Biletele sunt rezervate 10 minute.',
        cart_method_receive_tickets: 'Cum vrei să primești biletele?',
        cart_method_receive_tickets_label: 'Bilete electronice (Email)',
        cart_issuance_fee: 'Taxă de emitere bilete',
        cart_transaction_fee: 'Taxă de tranzacție',
        cart_your_seats: 'Locurile tale',
        cart_seated_together: 'Veți fi așezați împreună',
        cart_continue_with_billing: 'Continuați cu facturarea',
        cart_you_added_tickets: 'Ai {count} bilete în coș.',
        cart_you_have_to_login: 'Trebuie să te autentifici',
        cart_contact_details: 'Detalii de contact',
        cart_contact_details_info: 'Vei primi biletul și actualizări ale comenzii la adresa ta de email.',
        cart_change_contact_details: 'Schimbă detaliile de contact',
        cart_contact_details_title_modal: 'Introdu detaliile persoanei căruia vrei să îi trimiți biletele',
        cart_buy_tickets: 'Cumpără bilete',
        cart_payment_type_and_billing: 'Metodă de plată',
        cart_confirm_order: 'Confirmă comanda',
        cart_credit_cart: 'Card de credit sau debit',
        cart_expired: 'Se pare că nu ai adăugat un eveniment în coș sau sesiunea a expirat',
        waiting_payment: 'Așteptăm confirmarea plății...',
        select_payment_method: 'Alege metoda de plată',
        all_details_corect: 'Toate detaliile sunt corecte? Verifică și plasează comanda',
        give_it_up: 'Renunță',
        accept_terms_error: 'Trebuie să fii de acord cu termenii și condițiile',
        cart_full_name_error: 'Trebuie să introduci numele tău complet',
    },
};
